var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MainHeader'),_c('RouterView',{staticClass:"tp-body"}),_c('MainFooter',{staticClass:"tp-footer"}),_c('CompLeaveapp'),_c('CompFollowform'),(_vm.isPageLoading)?_c('PageLoader',{staticClass:"tp-loader",class:{none: !_vm.isShown}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }